import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "template"]

  connect() {
    this.index = 0
    this.loadExistingInspections()
    console.log('Connected inspections')
    this.updateCheckboxStyles()
  }

  loadExistingInspections() {
    const inspectionsValue = this.element.dataset.inspectionsValue;
    console.log(inspectionsValue)
    if (inspectionsValue) {
      const inspections = JSON.parse(inspectionsValue);
      inspections.forEach((inspection, index) => {
        this.addExistingInspection(inspection, index)
      })
    }
  }

  addExistingInspection(inspection, index) {
    const template = this.templateContent()
    template.querySelectorAll("[name]").forEach(element => {
      element.name = element.name.replace(/INDEX/g, index)
    })
    template.querySelectorAll("[data-index]").forEach(element => {
      element.dataset.index = index
    })
    template.querySelectorAll("[data-id]").forEach(element => {
      element.dataset.id = inspection.id
    })
    template.querySelector('input[name$="[data][inspection_date]"]').value = inspection.data.inspection_date
    template.querySelector('input[name$="[data][location]"]').value = inspection.data.location
    template.querySelector('input[name$="[data][inspector_name]"]').value = inspection.data.inspector_name
    template.querySelector('input[name$="[data][mileage]"]').value = inspection.data.mileage
    template.querySelector('textarea[name$="[data][general_notes]"]').value = inspection.data.general_notes

    this.containerTarget.appendChild(template)
    this.index++
    this.updateCheckboxStyles()
  }

  addInspection() {
    const template = this.templateContent()
    const index = this.index++
    template.querySelectorAll("[name]").forEach(element => {
      element.name = element.name.replace(/INDEX/g, index)
    })
    template.querySelectorAll("[data-index]").forEach(element => {
      element.dataset.index = index
    })
    this.containerTarget.appendChild(template)
    this.updateCheckboxStyles()
  }

  templateContent() {
    const template = this.templateTarget
    return template.content.cloneNode(true)
  }

  removeInspection(event) {
    event.preventDefault();
    const inspectionElement = event.target.closest(".inspection-entry");
    const inspectionId = inspectionElement.dataset.id;
  
    if (confirm("Are you sure you want to delete this inspection entry?")) {
      if (!inspectionId) {
        // If there's no ID, it's a new unsaved entry, so just remove it from the DOM
        inspectionElement.remove();
      } else {
        // For existing entries, send a DELETE request
        fetch(`/accounts/${this.data.get('accountId')}/vehicles/${this.data.get('vehicleId')}/delete_inspection_entry?inspection_entry_id=${inspectionId}`, {
          method: 'DELETE',
          headers: {
            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            'Content-Type': 'application/json'
          }
        }).then(response => {
          if (response.ok) {
            inspectionElement.remove();
          } else {
            return response.json().then(data => {
              throw new Error(data.error || 'Failed to delete the inspection entry');
            });
          }
        }).catch(error => {
          alert(error.message);
          console.error("Error:", error);
        });
      }
    }
  }
  
  

  updateCheckboxStyles() {
    this.element.querySelectorAll('.checkbox-toggle').forEach((checkbox) => {
      this.updateCheckboxStyle(checkbox)
      checkbox.addEventListener('change', () => this.updateCheckboxStyle(checkbox))
    })
  }

  updateCheckboxStyle(checkbox) {
    const label = checkbox.nextElementSibling
    if (checkbox.checked) {
      label.style.color = 'green'
    } else {
      label.style.color = 'red'
    }
  }
}
